<template functional>
  <div class="sample-video">
    <iframe
      :src="`https://content.jwplatform.com/previews/${props.videoId}-T92WUUWc`"
      itemprop="video"
      height="1080"
      width="1920"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'SampleVideo',
  props: {
    videoId: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.sample-video {
  position: relative;
  padding: 25px 0 52.1% 0;
  height: 0;
  width: 100%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
